import { useStaff } from '@/api/staff';

/**
 * Picker for "support owner" / "assigned operator" — backed by the
 * real users in /staff (i.e. Google-SSO'd operator accounts).
 *
 * Stores the operator's email as the value. If the current value isn't
 * in the operator list (e.g. legacy free-text label like "StatsDrone"),
 * it's shown as-is with a "(not an operator)" suffix so the operator
 * can decide whether to clear it.
 */
export function OperatorPicker({
  value,
  onChange,
  disabled,
  placeholder = 'Unassigned',
}: {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  placeholder?: string;
}) {
  const { data: operators = [], isLoading } = useStaff();
  const active = operators.filter(o => o.status === 'active');
  const isLegacy = value && !active.some(o => o.email === value);

  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled || isLoading}
      className="w-full h-8 px-2 rounded-md bg-surface border border-border focus:border-accent focus:outline-none text-sm"
    >
      <option value="">{placeholder}</option>
      {active.map(o => (
        <option key={o.id} value={o.email}>
          {o.name || o.email} {o.role !== 'platform_admin' ? `· ${o.role}` : ''}
        </option>
      ))}
      {isLegacy && (
        <option value={value}>
          {value} (legacy, not a current operator)
        </option>
      )}
    </select>
  );
}
